import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Principal.css';
import CONFIG from '../../config.js';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import CalendarioResumenEventos from '../mensajes/CalendarioResumenEventos.js';
import RegistroAsistencia from './RegistroAsistencia.js';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const URL_INFO       = `${CONFIG.API_URL}/info_principal.php`;
const URL_CALENDARIO = `${CONFIG.API_URL}/operarCalendario.php`;

function PrincipalSecretaria({ registroAsistencia, ListadosDeCursos, cargandoAsistencia = false, mensajesSinLeer, rol, configuracion }) {
    // --- Tarjetas (carga rápida) ---
    const [usuarios,    setUsuarios]    = useState(null);
    const [cursos,      setCursos]      = useState(null);
    const [estudiantes, setEstudiantes] = useState(null);
    const [docentes,    setDocentes]    = useState(null);
    const [cargandoContadores, setCargandoContadores] = useState(true);

    // --- Gráficos (carga diferida) ---
    const [matriculaData,  setMatriculaData]  = useState([]);
    const [matriculaDataI, setMatriculaDataI] = useState([]);
    const [matriculaDataP, setMatriculaDataP] = useState([]);
    const [cargandoGraficos, setCargandoGraficos] = useState(true);

    const [eventos, setEventos] = useState([]);
    const [modalAsistencia, setModalAsistencia] = useState(false);

    const userId = localStorage.getItem('loggedUserId');
    const cicloActual = new Date().getFullYear();
    const loggeduserNivelId = localStorage.getItem('loggeduserNivelId');

    useEffect(() => {
        const nivelParam = loggeduserNivelId ? `&id_nivel=${loggeduserNivelId}` : '';
        const baseUrl = `${URL_INFO}?ciclo=${cicloActual}${nivelParam}`;

        // Fetch 1: contadores ultrarrápidos
        axios.get(`${baseUrl}&modo=contadores`)
            .then(res => {
                if (res.data) {
                    setUsuarios(res.data.usuarios       ?? 0);
                    setCursos(res.data.cursos           ?? 0);
                    setEstudiantes(res.data.estudiantes ?? 0);
                    setDocentes(res.data.docentes       ?? 0);
                }
            })
            .catch(err => console.error('Error contadores secretaria:', err))
            .finally(() => setCargandoContadores(false));

        // Fetch 2: gráficos diferidos
        axios.get(`${baseUrl}&modo=graficos`)
            .then(res => {
                if (res.data) {
                    setMatriculaData(res.data.formaciones ?? []);
                    setMatriculaDataI(res.data.matriculaI ?? []);
                    setMatriculaDataP(res.data.matriculaP ?? []);
                }
            })
            .catch(err => console.error('Error gráficos secretaria:', err))
            .finally(() => setCargandoGraficos(false));

        obtenerEventos();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const mostrarNombre = (orden) => {
        const map = { S2: 'Sala de 2', S3: 'Sala de 3', S4: 'Sala de 4', S5: 'Sala de 5', In: 'Esp. Institucional' };
        return map[orden] || `${orden}°`;
    };

    const obtenerEventos = async () => {
        try {
            const res = await axios.get(URL_CALENDARIO);
            if (!Array.isArray(res.data)) { setEventos([]); return; }
            const rolN = parseInt(rol, 10);
            const tiposAdmin   = ['todos','todosA','todosD','todosE','todosT','todosM'];
            const tiposDocente = ['todos','todosD','todosDC','todosDETC'];
            const mapRol = {
                1: tiposAdmin, 2: tiposAdmin, 3: tiposAdmin, 4: tiposAdmin,
                5: tiposDocente, 6: tiposDocente,
                7: ['todos','todosE','todosEC','todosDETC'],
                8: ['todos','todosT','todosE','todoTC','todosDETC'],
                9: ['todos','todosD'],
                12: ['todos','todosM'],
            };
            const tipos = mapRol[rolN] || [];
            setEventos(res.data.filter(e => e.creada_por == userId || tipos.includes(e.tipo_recordatorio)));
        } catch (err) {
            console.error('Error eventos secretaria:', err);
        }
    };

    const TarjetaSkeleton = () => (
        <div className="cuadro-info-simple" style={{ background: '#e5e7eb', animation: 'pulse 1.4s ease-in-out infinite' }}>
            <div style={{ width: '60%', height: '16px', background: '#d1d5db', borderRadius: 6, margin: '8px auto' }} />
            <div style={{ width: '40%', height: '24px', background: '#d1d5db', borderRadius: 6, margin: '4px auto' }} />
        </div>
    );

    const CuadroInfo = ({ icono, valor, label, grad1, grad2 }) => (
        <div className='cuadro-info-simple' style={{
            background: `linear-gradient(266deg, ${grad1} 0%, ${grad2} 100%)`
        }}>
            <i className={`fa-solid ${icono}`}></i>
            <div className='texto-info1' style={{ color: configuracion.color_terciario }}>
                {valor !== null ? `+ ${valor}` : '...'} {label}
            </div>
        </div>
    );

    return (
        <div>
            <div className='row'>
                {/* Calendario */}
                <div className='col-12 col-md-6 col-lg-3'>
                    <CalendarioResumenEventos userId={userId} rol={rol} eventos={eventos} />
                </div>

                {/* Gráficos + Tarjetas */}
                <div className='col-12 col-md-6 col-lg-5'>
                    <div className='card px-4 pb-4'>
                        {cargandoGraficos ? (
                            <div className='text-center py-4 text-muted small'>
                                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                Cargando estadísticas de matrícula...
                            </div>
                        ) : (
                            <>
                                {matriculaData?.length > 0 && matriculaData.map((formacion) => {
                                    if (!formacion.matricula || formacion.matricula.length === 0) return null;
                                    const colores = [
                                        'rgba(15, 187, 141, 0.77)',
                                        'rgba(247, 26, 26, 0.8)',
                                        'rgba(54, 163, 235, 0.68)',
                                        'rgba(235, 54, 211, 0.8)',
                                        'rgba(237, 250, 55, 0.97)',
                                        'rgba(252, 171, 51, 0.88)'
                                    ];
                                    const años    = [...new Set(formacion.matricula.map(m => m.año))];
                                    const ordenes = [...new Set(formacion.matricula.map(m => m.orden))];
                                    const datasets = ordenes.map((orden, i) => ({
                                        label: `${orden}°`,
                                        data: años.map(año => {
                                            const item = formacion.matricula.find(m => m.año === año && m.orden === orden);
                                            return item ? Number(item.total_estudiantes) : 0;
                                        }),
                                        backgroundColor: colores[i % colores.length]
                                    }));
                                    return (
                                        <div key={formacion.id_formacion}>
                                            <h6 className='mt-1'>{formacion.nombre_formacion} - nivel: {formacion.nivel}</h6>
                                            <div className='principal-grafico'>
                                                <Bar data={{ labels: años, datasets }} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>

                    {/* Tarjetas */}
                    <div className='row mt-2'>
                        <div className='col-6 col-md-3 col-lg-6 d-flex justify-content-center'>
                            {cargandoContadores ? <TarjetaSkeleton /> : (
                                <CuadroInfo icono="fa-users"           valor={usuarios}    label="Usuarios"    grad1={configuracion.color_secundario} grad2={configuracion.color_principal} />
                            )}
                        </div>
                        <div className='col-6 col-md-3 col-lg-6 d-flex justify-content-center'>
                            {cargandoContadores ? <TarjetaSkeleton /> : (
                                <CuadroInfo icono="fa-boxes-stacked"   valor={cursos}      label="cursos"      grad1={configuracion.color_principal} grad2={configuracion.color_secundario} />
                            )}
                        </div>
                        <div className='col-6 col-md-3 col-lg-6 d-flex justify-content-center'>
                            {cargandoContadores ? <TarjetaSkeleton /> : (
                                <CuadroInfo icono="fa-graduation-cap"  valor={estudiantes} label="estudiantes" grad1={configuracion.color_secundario} grad2={configuracion.color_principal} />
                            )}
                        </div>
                        <div className='col-6 col-md-3 col-lg-6 d-flex justify-content-center'>
                            {cargandoContadores ? <TarjetaSkeleton /> : (
                                <CuadroInfo icono="fa-chalkboard-user" valor={docentes}    label="Docentes"    grad1={configuracion.color_principal} grad2={configuracion.color_secundario} />
                            )}
                        </div>
                    </div>
                </div>

                {/* Asistencia con lazy render */}
                <div className='col-12 col-md-12 col-lg-4 card'>
                    <div className='card p-2 my-2'>
                        <h6>
                            <span className='me-4'>Resumen registro de asistencia - {cicloActual}</span>
                            <button
                                className='btn btn-outline-secondary btn-sm ms-4'
                                onClick={() => setModalAsistencia(true)}
                            >
                                <i className="fa-solid fa-magnifying-glass-chart"></i>
                            </button>
                        </h6>
                        {!cargandoAsistencia ? (
                            <RegistroAsistencia
                                anioRegistro={cicloActual}
                                registroAsistencia={registroAsistencia}
                                ListadosDeCursos={ListadosDeCursos}
                                configuracion={configuracion}
                            />
                        ) : (
                            <div className='text-center py-4 text-muted small'>
                                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                Cargando asistencia...
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {modalAsistencia && (
                <div className="modal-asistencia-overlay" onClick={() => setModalAsistencia(false)}>
                    <div className="modal-asistencia-contenido" onClick={(e) => e.stopPropagation()}>
                        <button className="btn-cerrar-modal" onClick={() => setModalAsistencia(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <RegistroAsistencia
                            anioRegistro={cicloActual}
                            registroAsistencia={registroAsistencia}
                            ListadosDeCursos={ListadosDeCursos}
                            configuracion={configuracion}
                            tipo="full"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default PrincipalSecretaria;
